import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { forkJoin, Subject, takeUntil } from 'rxjs';
import { catchError, of, finalize } from 'rxjs';
import { TiposService } from '../../../../shared/services/tipos.service';
import { MarcaService } from '../../../../shared/services/marca.service';
import { CombustibleService } from '../../../../shared/services/combustible.service';
import { VehiclesService } from '../../../../shared/services/vehicles.service';
import { PlanMantenimientoService } from '../../../../shared/services/plan-mantenimiento.services';
import Swal from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-crear-plan-mantenimientos',
  templateUrl: './crear-plan-mantenimientos.component.html',
  styleUrls: ['./crear-plan-mantenimientos.component.scss']
})
export class CrearPlanMantenimientosComponent {
 formNuevo!: FormGroup;
 formActividades: FormGroup;
 
 tiposVehiculo: any[] = []; // Variable para almacenar los tipos de vehículo
 marcasVehiculo: any[] = []; // Variable para almacenar las marcas de vehículo
 combustibles: any[] = []; // Variable para almacenar los tipos de combustible

 combustibleSeleccionado: any;
 marcaSeleccionada: any;
 tipoVehiculoSeleccionado: any;  
 todosCilindrajes = false;
 todosModelos = false;
 planCreadoId: number | null = null;
 mostrarRegistroActividades = false;
  modoEdicion = false;
  planId: number | null = null;
  cargandoCatalogos = true;
  cargandoPlan = false;
  constructor(
    private fb: FormBuilder,
    private tiposService: TiposService,
    private marcaService: MarcaService,
    private combustibleService: CombustibleService,
    private vehiclesService: VehiclesService,
    private planMantenimientoService: PlanMantenimientoService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    

    this.formActividades = this.fb.group({
      actividades: this.fb.array([])
    });
  }


   private destroy$ = new Subject<void>();

  ngOnInit(): void {
    const idParam = this.route.snapshot.paramMap.get('id');

    if (idParam) {
      this.modoEdicion = true;
      this.planId = Number(idParam);
      console.log('Modo edición activado. ID del plan:', this.planId);
    }

    this.inicializarFormulario();
    this.cargarCatalogosYPlan();
  }
  inicializarFormulario() {
   this.formNuevo = this.fb.group({
      nombre: [{ value: '', disabled: true }],
      clase: ['', Validators.required],
      marca: ['', Validators.required],
      combustible: ['', Validators.required],
      todosModelos: [false],
      modeloDesde: ['', Validators.required], // Campo requerido si "todosModelos" es falso
      modeloHasta: ['', Validators.required],// Campo requerido si "todosModelos" es falso
      todosCilindrajes: [false],      
      cilindrajeDesde: ['', Validators.required], // Campo requerido si "todosCilindrajes" es falso
      cilindrajeHasta: ['', Validators.required], // Campo requerido si "todosCilindrajes" es falso
      descripcionPlan: ['', Validators.required],
      todosAnios: [false],
      
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Carga los catálogos (tipos vehículo, marcas, combustibles) en paralelo.
   * Solo cuando TODOS terminan, configura las suscripciones del formulario
   * y, si es edición, carga el plan. Esto evita el race condition donde
   * patchValue dispara valueChanges antes de que los arrays existan.
   */
  private cargarCatalogosYPlan(): void {
    this.cargandoCatalogos = true;

    forkJoin({
      tiposVehiculo: this.tiposService.getTipos(),
      marcas: this.marcaService.getMarcas(),
      combustibles: this.combustibleService.getAllCombustibles()
    })
      .pipe(finalize(() => (this.cargandoCatalogos = false)))
      .subscribe({
        next: ({ tiposVehiculo, marcas, combustibles }) => {
          this.tiposVehiculo = tiposVehiculo;
          this.marcasVehiculo = marcas;
          this.combustibles = combustibles;

          this.configurarSuscripcionesFormulario();

          if (this.modoEdicion && this.planId) {
            this.cargarPlan(this.planId);
          }
        },
        error: (err) => {
          console.error('Error al cargar catálogos:', err);
          Swal.fire({
            icon: 'error',
            title: 'Error al cargar datos',
            text: 'No fue posible cargar la información necesaria para el formulario.',
            confirmButtonText: 'Aceptar'
          });
        }
      });
  }

  private configurarSuscripcionesFormulario(): void {
    this.formNuevo.get('todosModelos')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(valor => {
        this.todosModelos = !!valor;
        this.aplicarValidacionesModelos();
        this.generarNombrePlan();
      });

    this.formNuevo.get('todosCilindrajes')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(valor => {
        this.todosCilindrajes = !!valor;
        this.aplicarValidacionesCilindrajes();
        this.generarNombrePlan();
      });

    this.formNuevo.get('combustible')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(id => {
        this.combustibleSeleccionado = this.combustibles.find(c => c.id === id);
        this.generarNombrePlan();
      });

    this.formNuevo.get('marca')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(id => {
        const marca = this.marcasVehiculo.find(m => m.id === id);
        this.marcaSeleccionada = marca?.marca;
        this.generarNombrePlan();
      });

    this.formNuevo.get('clase')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(idTipos => {
        const tipoVehiculo = this.tiposVehiculo.find(t => t.idTipos === idTipos);
        this.tipoVehiculoSeleccionado = tipoVehiculo?.tipos;
        this.generarNombrePlan();
      });

    this.formNuevo.get('modeloDesde')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.validateModelRange();
        this.generarNombrePlan();
      });

    this.formNuevo.get('modeloHasta')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.validateModelRange();
        this.generarNombrePlan();
      });

    this.formNuevo.get('cilindrajeDesde')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.validateCilindrajeRange();
        this.generarNombrePlan();
      });

    this.formNuevo.get('cilindrajeHasta')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.validateCilindrajeRange();
        this.generarNombrePlan();
      });

    this.aplicarValidacionesModelos();
    this.aplicarValidacionesCilindrajes();
  }

  cargarPlan(planId: number): void {
    this.cargandoPlan = true;

    this.planMantenimientoService.getById(planId)
      .pipe(finalize(() => (this.cargandoPlan = false)))
      .subscribe({
        next: (plan: any) => {
          console.log('Cargando plan de mantenimiento con ID:', planId, plan.data.nombre);
          this.formNuevo.patchValue({
            nombre: plan.data.nombre,
            clase: plan.data.claseId,
            marca: plan.data.marcaId,
            combustible: plan.data.combustibleId,
            todosModelos: plan.data.todosModelos,
            modeloDesde: plan.data.modeloDesde,
            modeloHasta: plan.data.modeloHasta,
            todosCilindrajes: plan.data.todosCilindrajes,
            cilindrajeDesde: plan.data.cilindrajeDesde,
            cilindrajeHasta: plan.data.cilindrajeHasta,
            descripcionPlan: plan.data.descripcion
          });

          this.todosModelos = !!plan.data.todosModelos;
          this.todosCilindrajes = !!plan.data.todosCilindrajes;
          this.aplicarValidacionesModelos();
          this.aplicarValidacionesCilindrajes();
        },
        error: (error) => {
          console.error('Error al cargar el plan de mantenimiento:', error);
          Swal.fire({
            icon: 'error',
            title: 'Error al cargar el plan',
            text: 'No fue posible cargar el plan de mantenimiento. Intente nuevamente.',
            confirmButtonText: 'Aceptar'
          });
        }
      });
  }
  private aplicarValidacionesModelos(): void {
    const todosModelos = !!this.formNuevo.get('todosModelos')?.value;
    const modeloDesde = this.formNuevo.get('modeloDesde');
    const modeloHasta = this.formNuevo.get('modeloHasta');

    if (todosModelos) {
      modeloDesde?.clearValidators();
      modeloHasta?.clearValidators();
      modeloDesde?.reset();
      modeloHasta?.reset();
      modeloDesde?.disable({ emitEvent: false });
      modeloHasta?.disable({ emitEvent: false });
    } else {
      modeloDesde?.enable({ emitEvent: false });
      modeloHasta?.enable({ emitEvent: false });
      modeloDesde?.setValidators([Validators.required]);
      modeloHasta?.setValidators([Validators.required]);
    }

    modeloDesde?.updateValueAndValidity({ emitEvent: false });
    modeloHasta?.updateValueAndValidity({ emitEvent: false });
    this.validateModelRange();
  }

  private aplicarValidacionesCilindrajes(): void {
    const todosCilindrajes = !!this.formNuevo.get('todosCilindrajes')?.value;
    const cilindrajeDesde = this.formNuevo.get('cilindrajeDesde');
    const cilindrajeHasta = this.formNuevo.get('cilindrajeHasta');

    if (todosCilindrajes) {
      cilindrajeDesde?.clearValidators();
      cilindrajeHasta?.clearValidators();
      cilindrajeDesde?.reset();
      cilindrajeHasta?.reset();
      cilindrajeDesde?.disable({ emitEvent: false });
      cilindrajeHasta?.disable({ emitEvent: false });
    } else {
      cilindrajeDesde?.enable({ emitEvent: false });
      cilindrajeHasta?.enable({ emitEvent: false });
      cilindrajeDesde?.setValidators([Validators.required]);
      cilindrajeHasta?.setValidators([Validators.required]);
    }

    cilindrajeDesde?.updateValueAndValidity({ emitEvent: false });
    cilindrajeHasta?.updateValueAndValidity({ emitEvent: false });
    this.validateCilindrajeRange();
  }

   private cargarTiposVehiculo(): void {
      this.tiposService.getTipos()
        .pipe(
          catchError(error => {
            console.error('Error al cargar los tipos de vehículo:', error);
            return of([]); // Retorna un observable vacío en caso de error
          })
        )
        .subscribe((tipos: any[]) => {
        //  console.log('Tipos de vehículo cargados:', tipos);
          // Aquí puedes asignar los tipos a una variable para usarlos en tu componente
          this.tiposVehiculo = tipos;
        });
    }

    private cargarMarcas(): void {
      this.marcaService.getMarcas()
        .pipe(
          catchError(error => {
            console.error('Error al cargar las marcas de vehículo:', error);
            return of([]); // Retorna un observable vacío en caso de error
          })
        )
        .subscribe((marcas: any[]) => {
          // Aquí puedes asignar las marcas a una variable para usarlas en tu componente
          this.marcasVehiculo = marcas;
        });
    }

    private cargarTipoCombustible(): void {
      this.combustibleService.getAllCombustibles()
        .pipe(
          catchError(error => {
            console.error('Error al cargar los tipos de combustible:', error);
            return of([]); // Retorna un observable vacío en caso de error
          })
        )
        .subscribe((combustibles: any[]) => {
          // Aquí puedes asignar los combustibles a una variable para usarlos en tu componente
          this.combustibles = combustibles;
        });
      }

  private capturarCamposPlan(): any {
    const formValue = this.formNuevo.getRawValue();

    return {
      nombre: formValue.nombre || '',
      claseId: formValue.clase,
      marcaId: formValue.marca,
      combustibleId: formValue.combustible,
      todosModelos: !!formValue.todosModelos,
      modeloDesde: formValue.todosModelos ? null : formValue.modeloDesde || null,
      modeloHasta: formValue.todosModelos ? null : formValue.modeloHasta || null,
      todosCilindrajes: !!formValue.todosCilindrajes,
      cilindrajeDesde: formValue.todosCilindrajes ? null : formValue.cilindrajeDesde || null,
      cilindrajeHasta: formValue.todosCilindrajes ? null : formValue.cilindrajeHasta || null,
      descripcionPlan: formValue.descripcionPlan || '',
     // todosAnios: !!formValue.todosAnios
    };
  }

 guardarPlan(): void {
  const datosPlan = this.capturarCamposPlan();

  if (this.formNuevo.invalid) {
    this.formNuevo.markAllAsTouched();
    return;
  }

  Swal.fire({
    title: this.modoEdicion ? 'Actualizando plan de mantenimiento...' : 'Guardando plan de mantenimiento...',
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    didOpen: () => Swal.showLoading()
  });

  const request$ = this.modoEdicion && this.planId
    ? this.planMantenimientoService.update(this.planId, datosPlan)
    : this.planMantenimientoService.create(datosPlan);

  request$.subscribe({
    next: (response: any) => {
      Swal.close();

      const exito = response?.codigo === 0;
     
      const mensaje = response?.message ||
        (this.modoEdicion ? 'Plan actualizado correctamente.' : 'Plan de mantenimiento guardado correctamente.');

      if (!exito) {
        Swal.fire({
          icon: 'error',
          title: this.modoEdicion ? 'No se pudo actualizar el plan' : 'No se pudo guardar el plan',
          text: mensaje,
          confirmButtonText: 'Aceptar'
        });
        return;
      }

      const planId = this.modoEdicion
        ? this.planId
        : (response?.plan?.id ?? response?.data?.id ?? response?.id);

      Swal.fire({
        icon: 'success',
        title: this.modoEdicion ? 'Plan actualizado' : 'Plan guardado',
        text: mensaje,
        confirmButtonText: 'Aceptar'
      }).then(() => {
        if (this.modoEdicion) {
          // En edición, normalmente vuelves al listado o a la vista de detalle
          this.router.navigate(['/mantenimientos/listar-plan-mantenimientos']);
        } else {
          // En creación, continúas al registro de actividades
          this.planCreadoId = planId;
          this.router.navigate(['/mantenimientos/crear-actividades-mantenimientos', planId]);
        }
      });
    },
    error: (error: any) => {
      Swal.close();
      console.error(`Error al ${this.modoEdicion ? 'actualizar' : 'guardar'} el plan de mantenimiento:`, error);
      Swal.fire({
        icon: 'error',
        title: `Error al ${this.modoEdicion ? 'actualizar' : 'guardar'} el plan`,
        text: `No fue posible ${this.modoEdicion ? 'actualizar' : 'guardar'} el plan. Intente nuevamente.`,
        confirmButtonText: 'Aceptar'
      });
    }
  });
}

  get actividadesArray(): FormArray {
    return this.formActividades.get('actividades') as FormArray;
  }

  agregarActividad(): void {
    this.actividadesArray.push(this.crearActividadFormGroup());
  }

  eliminarActividad(index: number): void {
    if (this.actividadesArray.length > 1) {
      this.actividadesArray.removeAt(index);
    }
  }

  private crearActividadFormGroup(): FormGroup {
    return this.fb.group({
      actividad_id: [null, Validators.required],
      frecuencia_km: [null],
      frecuencia_meses: [null],
      alerta_km: [null],
      alerta_dias: [null],
      obligatorio: [true],
      observaciones: [''],
      estado: [1],
      usuario_creacion: [1]
    });
  }

  guardarActividades(): void {
    if (!this.planCreadoId) {
      Swal.fire({
        icon: 'warning',
        title: 'Plan no creado',
        text: 'Debe guardar el plan antes de registrar actividades.',
        confirmButtonText: 'Aceptar'
      });
      return;
    }

    if (this.formActividades.invalid) {
      this.formActividades.markAllAsTouched();
      return;
    }

    const actividades = this.actividadesArray.controls.map((control: any) => {
      const valor = control.value;

      return {
        planMantenimientoId: this.planCreadoId,
        actividadId: valor.actividad_id,
        tipoControl: this.obtenerTipoControl(valor.frecuencia_km, valor.frecuencia_meses),
        frecuenciaKm: this.normalizarNumero(valor.frecuencia_km),
        frecuenciaMeses: this.normalizarNumero(valor.frecuencia_meses),
        alertaKm: this.normalizarNumero(valor.alerta_km),
        alertaDias: this.normalizarNumero(valor.alerta_dias),
        obligatoria: !!valor.obligatorio,
        estado: valor.estado ?? 1,
        usuarioCreacion: valor.usuario_creacion ?? 1
      };
    });

    Swal.fire({
      title: 'Guardando actividades...',
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading()
    });

    this.planMantenimientoService.createActividades(actividades).subscribe({
      next: () => {
        Swal.close();
        Swal.fire({
          icon: 'success',
          title: 'Actividades registradas',
          text: 'Las actividades fueron guardadas correctamente.',
          confirmButtonText: 'Aceptar'
        });
      },
      error: () => {
        Swal.close();
        Swal.fire({
          icon: 'error',
          title: 'Error al guardar actividades',
          text: 'No fue posible registrar las actividades del plan.',
          confirmButtonText: 'Aceptar'
        });
      }
    });
  }

  private obtenerTipoControl(frecuenciaKm: any, frecuenciaMeses: any): string {
    const tieneFrecuenciaKm = this.normalizarNumero(frecuenciaKm) !== null;
    const tieneFrecuenciaMeses = this.normalizarNumero(frecuenciaMeses) !== null;

    if (tieneFrecuenciaKm && tieneFrecuenciaMeses) {
      return 'KM_MESES';
    }

    if (tieneFrecuenciaKm) {
      return 'KM';
    }

    return 'MESES';
  }

  private normalizarNumero(valor: any): number | null {
    if (valor === null || valor === undefined || valor === '') {
      return null;
    }

    const numero = Number(valor);
    return Number.isFinite(numero) ? numero : null;
  }

get resumenPlan(): string {

  const clase = this.tipoVehiculoSeleccionado ?? 'Todas las clases';
  const marca = this.marcaSeleccionada ?? 'Todas las marcas';
  const combustible = this.combustibleSeleccionado?.nombre ?? 'Todos los combustibles';

  const todosModelos = this.formNuevo.get('todosModelos')?.value === true;
  const todosCilindrajes = this.formNuevo.get('todosCilindrajes')?.value === true;

  let modelos = 'sin definir';
  if (todosModelos) {
    modelos = 'todos los modelos';
  } else {
    const desde = this.formNuevo.get('modeloDesde')?.value;
    const hasta = this.formNuevo.get('modeloHasta')?.value;

    if (desde !== '' && desde != null && hasta !== '' && hasta != null) {
      const desdeNum = Number(desde);
      const hastaNum = Number(hasta);

      if (!Number.isNaN(desdeNum) && !Number.isNaN(hastaNum) && desdeNum > hastaNum) {
        modelos = `rango inválido: modelos ${desde} a ${hasta}`;
      } else {
        modelos = `modelos ${desde} al ${hasta}`;
      }
    }
  }

  let cilindrajes = 'sin definir';
  if (todosCilindrajes) {
    cilindrajes = 'todos los cilindrajes';
  } else {
    const desde = this.formNuevo.get('cilindrajeDesde')?.value;
    const hasta = this.formNuevo.get('cilindrajeHasta')?.value;

    if (desde !== '' && desde != null && hasta !== '' && hasta != null) {
      const desdeNum = Number(desde);
      const hastaNum = Number(hasta);

      if (!Number.isNaN(desdeNum) && !Number.isNaN(hastaNum) && desdeNum > hastaNum) {
        cilindrajes = `rango inválido: motores ${desde} a ${hasta} cc`;
      } else {
        cilindrajes = `motores entre ${desde} y ${hasta} cc`;
      }
    }
  }

  return `${clase} ${marca} ${combustible}, ${modelos}, con ${cilindrajes}.`;
}
seleccionarTodasClases(): void {
  const ids = this.tiposVehiculo.map(t => t.idTipos);
  this.formNuevo.get('clase')?.setValue(ids);
}

deseleccionarTodasClases(): void {
  this.formNuevo.get('clase')?.setValue([]);
}

 getCantidadVehiculosPlan(): number {
   const datosPlan = this.capturarCamposPlan();

     this.vehiclesService.getCantidadVehiculosPlan(datosPlan).subscribe(
      (cantidad: number) => {
        console.log('Cantidad de vehículos según el plan:', cantidad);
        return cantidad;
      },
      (error: any) => {
        console.error('Error al obtener la cantidad de vehículos según el plan:', error);
        return 0; // Retorna 0 en caso de error
      }
    );
   return 0; // Retorna 0 como valor por defecto
 }

 private generarNombrePlan(): void {
      const resumen = this.resumenPlan;
      const nombrePlan = `${this.tipoVehiculoSeleccionado ?? ''} ${this.marcaSeleccionada ?? ''} ${this.combustibleSeleccionado?.nombre ?? ''}`.trim();

      this.formNuevo.patchValue({
        nombre: nombrePlan,
        descripcionPlan: resumen
      }, { emitEvent: false });
}

//validar que el modeloDesde sea menor o igual al modeloHasta
validateModelRange(): void {
  const modeloDesde = this.formNuevo.get('modeloDesde')?.value;
  const modeloHasta = this.formNuevo.get('modeloHasta')?.value;
  const controlHasta = this.formNuevo.get('modeloHasta');

  if (this.formNuevo.get('todosModelos')?.value || !controlHasta?.enabled) {
    controlHasta?.setErrors(null);
    this.generarNombrePlan();
    return;
  }

  if (modeloDesde !== '' && modeloHasta !== '' && modeloDesde != null && modeloHasta != null && Number(modeloDesde) > Number(modeloHasta)) {
    const errors = { ...(controlHasta?.errors || {}), rangeError: true };
    controlHasta?.setErrors(errors);
  } else {
    const errors = { ...(controlHasta?.errors || {}) };
    delete errors.rangeError;
    controlHasta?.setErrors(Object.keys(errors).length ? errors : null);
  }

  this.generarNombrePlan();
}

//validar que el cilindrajeDesde sea menor o igual al cilindrajeHasta
validateCilindrajeRange(): void {
  const cilindrajeDesde = this.formNuevo.get('cilindrajeDesde')?.value;
  const cilindrajeHasta = this.formNuevo.get('cilindrajeHasta')?.value;
  const controlHasta = this.formNuevo.get('cilindrajeHasta');

  if (this.formNuevo.get('todosCilindrajes')?.value || !controlHasta?.enabled) {
    controlHasta?.setErrors(null);
    this.generarNombrePlan();
    return;
  }

  if (cilindrajeDesde !== '' && cilindrajeHasta !== '' && cilindrajeDesde != null && cilindrajeHasta != null && Number(cilindrajeDesde) > Number(cilindrajeHasta)) {
    const errors = { ...(controlHasta?.errors || {}), rangeError: true };
    controlHasta?.setErrors(errors);
  } else {
    const errors = { ...(controlHasta?.errors || {}) };
    delete errors.rangeError;
    controlHasta?.setErrors(Object.keys(errors).length ? errors : null);
  }

  this.generarNombrePlan();
}

get porcentajeCompletado(): number {
  const campos = [
    !!this.tipoVehiculoSeleccionado,
    !!this.marcaSeleccionada,
    !!this.combustibleSeleccionado?.nombre,
    this.formNuevo.get('todosModelos')?.value ||
      (!!this.formNuevo.get('modeloDesde')?.value && !!this.formNuevo.get('modeloHasta')?.value),
    this.formNuevo.get('todosCilindrajes')?.value ||
      (!!this.formNuevo.get('cilindrajeDesde')?.value && !!this.formNuevo.get('cilindrajeHasta')?.value),
  ];

  const completados = campos.filter(Boolean).length;
  return Math.round((completados / campos.length) * 100);
}


}
